import { BaseOdataUrl } from '../../../configVariables';
import {
    BroadcastMessageVersion,
    BroadcastMessageWithStatistic,
    ODataResult,
} from '../../../model';
import apiClient from '../../../utils/apiClient';

export const fetchBroadcastMessagesApiCall = async (
    query?: string
): Promise<ODataResult<BroadcastMessageWithStatistic[]>> => {
    const url = `${BaseOdataUrl}/BroadcastMessages${query}`;
    const result =
        await apiClient.get<ODataResult<BroadcastMessageWithStatistic[]>>(url);
    return result.data;
};

export const fetchBroadcastMessageVersions = async (
    messageId: string,
    query?: string
): Promise<ODataResult<BroadcastMessageVersion[]>> => {
    const url = `${BaseOdataUrl}/BroadcastMessages/${messageId}/GetVersions${query}`;
    const result =
        await apiClient.get<ODataResult<BroadcastMessageVersion[]>>(url);
    return result.data;
};
